import {jsonMember} from "typedjson";

export class PitAgreementTaskResult {

    @jsonMember({constructor: Number, isRequired: true})
    id: 0;

    @jsonMember({constructor: Number, isRequired: false})
    ord: 0;

    @jsonMember({constructor: String, isRequired: true})
    caption: string;

    @jsonMember({constructor: String, isRequired: false})
    value: string;
}
